import React from "react"
import { Paper, RaisedButton, Toggle } from "material-ui"
import strings from "../../localization/strings"
import PayPeriodSelector from "../../components/payroll/PayPeriodSelector"
import { IPayrollPayCalendar, IPayGroup, IDateRange, IDate } from "../../models"
import moment from "moment"
import PayCalendarSelector from "../../components/pay_calendar/PayCalendarSelector"
import PayGroupSelector from "../../components/paygroup_selector/PayGroupSelector"
import AppStateStore from "../../stores/AppStateStore"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import accountStore from "../../stores/AccountStore"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"

interface IProps {
	calculating: boolean
	viewByJob: boolean
	payrollDates: IDateRange
	payCalendarPayGroups: IPayGroup[]
	selectedPayCalendar: IPayrollPayCalendar
	selectedPayGroup: IPayGroup
	referenceDate: IDate
	handleChangeSelectedPayCalendar(selectedPayCalendar: IPayrollPayCalendar): void
	handleChangeSelectedPayGroup(selectedPayGroup: IPayGroup): void
	handleChangeReferenceDate(referenceDate: Date | string, payrollDates: IDateRange): void
	handleChangeViewByJob(viewByJob: boolean): void
	handleCalculate(): void
}

const PayrollTopCard: React.SFC<IProps> = (props: IProps) => {
	return (
		<Paper zDepth={1} className="page-paper" style={{ marginBottom: 25, minWidth: 1275 }}>
			<div style={{ fontSize: 25, fontWeight: "bold", paddingLeft: 35, paddingTop: 20 }}>
				{strings.Payroll}
			</div>
			<div style={{ fontSize: 18, textAlign: "center", width: "100%", top: 42, position: "absolute" }}>
				<span style={{ fontWeight: 600 }}>{strings.Pay_Period}: </span>
				{moment(props.payrollDates.StartDate).utc(true).format("ddd MMM. DD, YYYY")} &mdash; {moment(props.payrollDates.EndDate).utc(true).format("ddd MMM. DD, YYYY")}
			</div>
			<div style={{ textAlign: "center", marginTop: 20, display: "flex", justifyContent: "space-evenly" }}>
				<RaisedButton
					data-intercom-target={"menu-Payroll-Btn-CalculatePayroll"}
					secondary
					disabled={props.calculating}
					label={strings.Calculate_Payroll.toUpperCase()}
					onTouchTap={() =>
						AppStateStore.setConfirmDialogContent({
							content: strings.Are_you_sure_you_want_to_calculate_payroll,
							confirm: () => props.handleCalculate()
						})
					}
				/>
			</div>
			{permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) &&
				permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayrollByJob) &&
				<div style={{ display: "flex", justifyContent: "flex-end", }}>
					<Toggle
						data-intercom-target={"payroll_page_View_By_Job_Toggle"}
						toggled={props.viewByJob}
						onToggle={(e, value) => props.handleChangeViewByJob(value)}
						labelPosition="left"
						
						label={checkJobFieldAvailable('singular') ? `View Payroll By ${accountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.View_Payroll_By_Job}
						style={{ maxWidth: 175, marginRight: 35,}}
						
					/>
				</div>
			}
			<div style={{ marginTop: -15, paddingLeft: 20, paddingRight: 20, display: "flex", justifyContent: "space-between", position: "relative" }}>
				<PayPeriodSelector
					referenceDate={props.referenceDate}
					selectedPayGroupId={props.payCalendarPayGroups[0].Id}
					handleChangeDate={props.handleChangeReferenceDate}
				/>
				<div style={{ display: "flex" }}>
					<div>
						<PayCalendarSelector
							width={175}
							selectedPayrollPayCalendar={props.selectedPayCalendar}
							handleSelect={props.handleChangeSelectedPayCalendar}
						/>
					</div>
					<div style={{ marginLeft: 15 }}>
						<PayGroupSelector
							width={175}
							allowNonSelect
							payGroups={props.payCalendarPayGroups}
							selectedPayGroup={props.selectedPayGroup}
							handleSelect={props.handleChangeSelectedPayGroup}
						/>
					</div>
				</div>
			</div>
		</Paper>
	)
}

export default PayrollTopCard